export default function PetalAvatar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_813_17350"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="15"
        height="15"
      >
        <path d="M15 1H0.890015V15.11H15V1Z" fill="white" />
      </mask>
      <g mask="url(#mask0_813_17350)">
        <path
          d="M8.43686 10.8289C8.43816 9.92197 8.76593 9.04588 9.36019 8.3608C9.95446 7.67577 10.7755 7.22757 11.6731 7.09821V8.00387C11.6721 8.91083 11.3443 9.78705 10.75 10.4721C10.1557 11.1572 9.33459 11.6053 8.43686 11.7345V10.8289ZM7.9055 8.6273C7.61211 8.05258 7.20689 7.54223 6.71363 7.12624C6.82077 6.58561 7.08659 6.08912 7.47715 5.70024L7.9055 5.27193L8.33477 5.70024C8.72537 6.08912 8.99119 6.58561 9.09833 7.12624C8.60448 7.54394 8.19898 8.05596 7.9055 8.63231V8.6273ZM7.3751 10.8289V11.7295C6.47729 11.6004 5.656 11.1523 5.06153 10.4672C4.46705 9.78212 4.13917 8.9059 4.13783 7.99886V7.0932C5.03648 7.22248 5.85842 7.6713 6.45298 8.35742C7.04758 9.04354 7.37493 9.92096 7.3751 10.8289ZM8.43686 15.0118V12.8033C9.61846 12.6709 10.7098 12.108 11.5026 11.2219C12.2955 10.3359 12.7341 9.18881 12.7349 7.99986V5.99844H12.2045C11.4497 5.99811 10.7054 6.17571 10.032 6.51681C9.84652 5.92852 9.52176 5.39365 9.08534 4.95771L7.9055 3.77887L6.72662 4.95771C6.2902 5.39365 5.96544 5.92852 5.77998 6.51681C5.10656 6.17571 4.36228 5.99811 3.60742 5.99844H3.07706V7.99986C3.0778 9.18881 3.51647 10.3359 4.30929 11.2219C5.10213 12.108 6.1935 12.6709 7.3751 12.8033V15.0118C5.56553 14.8745 3.87956 14.0414 2.67126 12.6874C1.46296 11.3333 0.826342 9.56379 0.89505 7.75033C0.963758 5.93687 1.73244 4.22059 3.03974 2.96189C4.34702 1.70319 6.09121 1 7.90596 1C9.72075 1 11.4649 1.70319 12.7722 2.96189C14.0796 4.22059 14.8482 5.93687 14.9169 7.75033C14.9856 9.56379 14.3489 11.3333 13.1407 12.6874C11.9323 14.0414 10.2464 14.8745 8.43686 15.0118Z"
          fill="#64B303"
          className="path-fill"
        />
      </g>
    </svg>
  );
}
